import { useState, useRef, useEffect } from 'react';

const DESTINATION_COUNTRY_MAP = {
  'delhi': 'India', 'mumbai': 'India', 'bangalore': 'India', 'chennai': 'India', 'kolkata': 'India',
  'hyderabad': 'India', 'pune': 'India', 'jaipur': 'India', 'goa': 'India', 'kerala': 'India',
  'agra': 'India', 'varanasi': 'India', 'udaipur': 'India', 'manali': 'India', 'shimla': 'India',
  'darjeeling': 'India', 'rishikesh': 'India', 'amritsar': 'India', 'ladakh': 'India', 'leh': 'India',
  'andaman': 'India', 'ooty': 'India', 'mysore': 'India', 'kochi': 'India', 'munnar': 'India',

  'singapore': 'Singapore', 'kuala lumpur': 'Malaysia', 'penang': 'Malaysia', 'langkawi': 'Malaysia',
  'bangkok': 'Thailand', 'phuket': 'Thailand', 'chiang mai': 'Thailand', 'pattaya': 'Thailand', 'krabi': 'Thailand',
  'bali': 'Indonesia', 'jakarta': 'Indonesia', 'yogyakarta': 'Indonesia',
  'hanoi': 'Vietnam', 'ho chi minh': 'Vietnam', 'da nang': 'Vietnam', 'hoi an': 'Vietnam',
  'manila': 'Philippines', 'cebu': 'Philippines', 'boracay': 'Philippines',
  'siem reap': 'Cambodia', 'phnom penh': 'Cambodia',

  'dubai': 'UAE', 'abu dhabi': 'UAE', 'sharjah': 'UAE',
  'doha': 'Qatar', 'riyadh': 'Saudi Arabia', 'jeddah': 'Saudi Arabia',
  'muscat': 'Oman', 'bahrain': 'Bahrain', 'kuwait': 'Kuwait',

  'paris': 'France', 'nice': 'France', 'lyon': 'France',
  'london': 'United Kingdom', 'edinburgh': 'United Kingdom', 'manchester': 'United Kingdom',
  'rome': 'Italy', 'milan': 'Italy', 'venice': 'Italy', 'florence': 'Italy',
  'barcelona': 'Spain', 'madrid': 'Spain', 'seville': 'Spain',
  'berlin': 'Germany', 'munich': 'Germany', 'frankfurt': 'Germany',
  'amsterdam': 'Netherlands', 'brussels': 'Belgium', 'vienna': 'Austria',
  'zurich': 'Switzerland', 'geneva': 'Switzerland', 'prague': 'Czech Republic',
  'budapest': 'Hungary', 'athens': 'Greece', 'santorini': 'Greece',
  'lisbon': 'Portugal', 'porto': 'Portugal', 'dublin': 'Ireland',
  'stockholm': 'Sweden', 'copenhagen': 'Denmark', 'oslo': 'Norway', 'helsinki': 'Finland',

  'new york': 'United States', 'los angeles': 'United States', 'san francisco': 'United States',
  'las vegas': 'United States', 'miami': 'United States', 'chicago': 'United States',
  'seattle': 'United States', 'boston': 'United States', 'washington': 'United States',
  'hawaii': 'United States', 'orlando': 'United States',
  'toronto': 'Canada', 'vancouver': 'Canada', 'montreal': 'Canada',
  'cancun': 'Mexico', 'mexico city': 'Mexico',

  'sydney': 'Australia', 'melbourne': 'Australia', 'gold coast': 'Australia', 'brisbane': 'Australia',
  'auckland': 'New Zealand', 'queenstown': 'New Zealand',

  'tokyo': 'Japan', 'osaka': 'Japan', 'kyoto': 'Japan', 'hokkaido': 'Japan',
  'seoul': 'South Korea', 'busan': 'South Korea',
  'hong kong': 'Hong Kong', 'macau': 'Macau',
  'taipei': 'Taiwan', 'beijing': 'China', 'shanghai': 'China',

  'colombo': 'Sri Lanka', 'kandy': 'Sri Lanka', 'kathmandu': 'Nepal', 'pokhara': 'Nepal',
  'dhaka': 'Bangladesh', 'maldives': 'Maldives', 'male': 'Maldives', 'thimphu': 'Bhutan',

  'cape town': 'South Africa', 'johannesburg': 'South Africa',
  'cairo': 'Egypt', 'marrakech': 'Morocco', 'nairobi': 'Kenya', 'zanzibar': 'Tanzania',
  'mauritius': 'Mauritius', 'seychelles': 'Seychelles'
};

const detectCountryFromDestination = (destination) => {
  if (!destination) return 'default';
  const lowerDest = destination.toLowerCase().trim();

  if (DESTINATION_COUNTRY_MAP[lowerDest]) {
    return DESTINATION_COUNTRY_MAP[lowerDest];
  }

  for (const [key, country] of Object.entries(DESTINATION_COUNTRY_MAP)) {
    if (lowerDest.includes(key) || key.includes(lowerDest)) {
      return country;
    }
  }

  return 'default';
};

const ChevronDownIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const ExternalLinkIcon = () => (
  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
  </svg>
);

const GoogleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

const REGION_SERVICES = {
  rideshare: {
    'India': [
      { name: 'Ola', url: 'https://www.olacabs.com', color: '#1C8C3B' },
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' }
    ],
    'United States': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' },
      { name: 'Lyft', url: 'https://www.lyft.com', color: '#FF00BF' }
    ],
    'Singapore': [
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' }
    ],
    'Malaysia': [
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' }
    ],
    'Thailand': [
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' },
      { name: 'Bolt', url: 'https://bolt.eu', color: '#34D186' }
    ],
    'Indonesia': [
      { name: 'Gojek', url: 'https://www.gojek.com', color: '#00880F' },
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' }
    ],
    'Vietnam': [
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' }
    ],
    'Philippines': [
      { name: 'Grab', url: 'https://www.grab.com', color: '#00B14F' }
    ],
    'United Kingdom': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' },
      { name: 'Bolt', url: 'https://bolt.eu', color: '#34D186' }
    ],
    'Germany': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' },
      { name: 'FREE NOW', url: 'https://www.free-now.com', color: '#FF5F00' }
    ],
    'France': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' },
      { name: 'Bolt', url: 'https://bolt.eu', color: '#34D186' }
    ],
    'UAE': [
      { name: 'Careem', url: 'https://www.careem.com', color: '#4CAF50' },
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' }
    ],
    'Saudi Arabia': [
      { name: 'Careem', url: 'https://www.careem.com', color: '#4CAF50' },
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' }
    ],
    'Australia': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' },
      { name: 'DiDi', url: 'https://www.didiglobal.com', color: '#FF7B00' }
    ],
    'default': [
      { name: 'Uber', url: 'https://www.uber.com', color: '#000000' }
    ]
  },
  foodDelivery: {
    'India': [
      { name: 'Zomato', url: 'https://www.zomato.com', color: '#E23744' },
      { name: 'Swiggy', url: 'https://www.swiggy.com', color: '#FC8019' }
    ],
    'United States': [
      { name: 'DoorDash', url: 'https://www.doordash.com', color: '#FF3008' },
      { name: 'Uber Eats', url: 'https://www.ubereats.com', color: '#000000' }
    ],
    'United Kingdom': [
      { name: 'Deliveroo', url: 'https://deliveroo.co.uk', color: '#00CCBC' },
      { name: 'Just Eat', url: 'https://www.just-eat.co.uk', color: '#FF8000' }
    ],
    'Singapore': [
      { name: 'GrabFood', url: 'https://www.grab.com/sg/food', color: '#00B14F' },
      { name: 'Foodpanda', url: 'https://www.foodpanda.sg', color: '#D70F64' }
    ],
    'Malaysia': [
      { name: 'GrabFood', url: 'https://www.grab.com/my/food', color: '#00B14F' },
      { name: 'Foodpanda', url: 'https://www.foodpanda.my', color: '#D70F64' }
    ],
    'Thailand': [
      { name: 'GrabFood', url: 'https://www.grab.com/th/food', color: '#00B14F' },
      { name: 'Foodpanda', url: 'https://www.foodpanda.co.th', color: '#D70F64' }
    ],
    'Indonesia': [
      { name: 'GoFood', url: 'https://www.gojek.com/gofood', color: '#00880F' },
      { name: 'GrabFood', url: 'https://www.grab.com/id/food', color: '#00B14F' }
    ],
    'UAE': [
      { name: 'Talabat', url: 'https://www.talabat.com', color: '#FF5A00' },
      { name: 'Deliveroo', url: 'https://deliveroo.ae', color: '#00CCBC' }
    ],
    'Germany': [
      { name: 'Lieferando', url: 'https://www.lieferando.de', color: '#FF8000' },
      { name: 'Wolt', url: 'https://wolt.com', color: '#009DE0' }
    ],
    'France': [
      { name: 'Uber Eats', url: 'https://www.ubereats.com', color: '#000000' },
      { name: 'Deliveroo', url: 'https://deliveroo.fr', color: '#00CCBC' }
    ],
    'Australia': [
      { name: 'Uber Eats', url: 'https://www.ubereats.com', color: '#000000' },
      { name: 'Menulog', url: 'https://www.menulog.com.au', color: '#FF8000' }
    ],
    'default': [
      { name: 'Uber Eats', url: 'https://www.ubereats.com', color: '#000000' }
    ]
  },
  tableBooking: {
    'India': [
      { name: 'Dineout', url: 'https://www.dineout.co.in', color: '#D4145A' },
      { name: 'EazyDiner', url: 'https://www.eazydiner.com', color: '#E53935' }
    ],
    'United States': [
      { name: 'OpenTable', url: 'https://www.opentable.com', color: '#DA3743' },
      { name: 'Resy', url: 'https://resy.com', color: '#004E92' }
    ],
    'United Kingdom': [
      { name: 'OpenTable', url: 'https://www.opentable.co.uk', color: '#DA3743' },
      { name: 'TheFork', url: 'https://www.thefork.co.uk', color: '#00665C' }
    ],
    'France': [
      { name: 'TheFork', url: 'https://www.thefork.fr', color: '#00665C' },
      { name: 'OpenTable', url: 'https://www.opentable.fr', color: '#DA3743' }
    ],
    'Germany': [
      { name: 'OpenTable', url: 'https://www.opentable.de', color: '#DA3743' },
      { name: 'Quandoo', url: 'https://www.quandoo.de', color: '#E4002B' }
    ],
    'Singapore': [
      { name: 'Chope', url: 'https://www.chope.co', color: '#FF1744' },
      { name: 'OpenTable', url: 'https://www.opentable.com.sg', color: '#DA3743' }
    ],
    'default': [
      { name: 'OpenTable', url: 'https://www.opentable.com', color: '#DA3743' }
    ]
  },
  trains: {
    'India': [
      { name: 'IRCTC', url: 'https://www.irctc.co.in', color: '#1A237E' }
    ],
    'United Kingdom': [
      { name: 'Trainline', url: 'https://www.thetrainline.com', color: '#03A9F4' }
    ],
    'Germany': [
      { name: 'Deutsche Bahn', url: 'https://www.bahn.de', color: '#EC0016' }
    ],
    'France': [
      { name: 'SNCF', url: 'https://www.sncf.com', color: '#82368C' }
    ],
    'Japan': [
      { name: 'JR Pass', url: 'https://www.jrpass.com', color: '#008000' }
    ],
    'Europe': [
      { name: 'Omio', url: 'https://www.omio.com', color: '#0090D9' },
      { name: 'Trainline', url: 'https://www.thetrainline.com', color: '#03A9F4' }
    ],
    'default': [
      { name: 'Omio', url: 'https://www.omio.com', color: '#0090D9' }
    ]
  },
  buses: {
    'India': [
      { name: 'RedBus', url: 'https://www.redbus.in', color: '#D84E55' },
      { name: 'AbhiBus', url: 'https://www.abhibus.com', color: '#E53935' }
    ],
    'United States': [
      { name: 'Greyhound', url: 'https://www.greyhound.com', color: '#002776' },
      { name: 'FlixBus', url: 'https://www.flixbus.com', color: '#73D700' }
    ],
    'Europe': [
      { name: 'FlixBus', url: 'https://www.flixbus.com', color: '#73D700' },
      { name: 'Omio', url: 'https://www.omio.com', color: '#0090D9' }
    ],
    'Southeast Asia': [
      { name: '12Go', url: 'https://12go.asia', color: '#00BCD4' },
      { name: 'Easybook', url: 'https://www.easybook.com', color: '#FF6B00' }
    ],
    'default': [
      { name: 'FlixBus', url: 'https://www.flixbus.com', color: '#73D700' }
    ]
  }
};

const getRegion = (country) => {
  const seaCountries = ['Singapore', 'Malaysia', 'Thailand', 'Vietnam', 'Philippines', 'Indonesia', 'Cambodia', 'Myanmar', 'Laos'];
  const europeCountries = ['Germany', 'France', 'Italy', 'Spain', 'Netherlands', 'Belgium', 'Austria', 'Switzerland', 'Poland', 'Czech Republic', 'Portugal', 'Greece', 'Sweden', 'Norway', 'Denmark', 'Finland'];

  if (seaCountries.includes(country)) return 'Southeast Asia';
  if (europeCountries.includes(country)) return 'Europe';
  return country;
};

const getServicesForRegion = (category, country) => {
  const services = REGION_SERVICES[category];
  if (!services) return [];

  if (services[country]) return services[country];

  const region = getRegion(country);
  if (services[region]) return services[region];

  return services['default'] || [];
};

const PROVIDER_META = {
  flights: [
    { key: 'googleFlights', name: 'Google Flights',  color: '#4285F4' },
    { key: 'skyscanner',    name: 'Skyscanner',      color: '#0770E3' },
    { key: 'kayak',         name: 'Kayak',           color: '#FF690F' },
    { key: 'makemytrip',    name: 'MakeMyTrip',      color: '#EB2226' }
  ],
  hotels: [
    { key: 'booking',     name: 'Booking.com',  color: '#003580' },
    { key: 'agoda',       name: 'Agoda',        color: '#5392F9' },
    { key: 'makemytrip',  name: 'MakeMyTrip',   color: '#EB2226' },
    { key: 'hostelworld', name: 'Hostelworld',  color: '#F65B5B' },
    { key: 'airbnb',      name: 'Airbnb',       color: '#FF5A5F' }
  ],
  activities: [
    { key: 'klook',        name: 'Klook',         color: '#FF5722' },
    { key: 'getyourguide', name: 'GetYourGuide',  color: '#FF5533' },
    { key: 'viator',       name: 'Viator',        color: '#328E04' },
    { key: 'tiqets',       name: 'Tiqets',        color: '#FF4D00' }
  ],
  trains: [
    { key: 'trainline', name: 'Trainline',  color: '#03A9F4' },
    { key: 'omio',      name: 'Omio',       color: '#0090D9' },
    { key: 'rome2rio',  name: 'Rome2Rio',   color: '#0096FF' },
    { key: 'irctc',     name: 'IRCTC',      color: '#1A237E' }
  ],
  buses: [
    { key: 'flixbus',  name: 'FlixBus',  color: '#73D700' },
    { key: 'redbus',   name: 'RedBus',   color: '#D84E55' },
    { key: 'omio',     name: 'Omio',     color: '#0090D9' },
    { key: 'rome2rio', name: 'Rome2Rio', color: '#0096FF' }
  ]
};

const CATEGORY_CONFIG = {
  flights: {
    color: 'blue',
    googleSearch: (dest, from) => `https://www.google.com/travel/flights?q=Flights+from+${encodeURIComponent(from || 'home')}+to+${encodeURIComponent(dest)}`
  },
  hotels: {
    color: 'orange',
    googleSearch: (dest) => `https://www.google.com/travel/hotels?q=hotels+in+${encodeURIComponent(dest)}`
  },
  activities: {
    color: 'green',
    googleSearch: (dest) => `https://www.google.com/search?q=things+to+do+in+${encodeURIComponent(dest)}`
  },
  trains: {
    color: 'indigo',
    googleSearch: (from, to) => `https://www.google.com/search?q=train+from+${encodeURIComponent(from || 'origin')}+to+${encodeURIComponent(to)}`
  },
  buses: {
    color: 'teal',
    googleSearch: (from, to) => `https://www.google.com/search?q=bus+from+${encodeURIComponent(from || 'origin')}+to+${encodeURIComponent(to)}`
  },
  rideshare: {
    color: 'purple',
    googleSearch: (dest) => `https://www.google.com/search?q=taxi+cab+booking+${encodeURIComponent(dest)}`,
    regionBased: true
  },
  foodDelivery: {
    color: 'red',
    googleSearch: (dest) => `https://www.google.com/search?q=food+delivery+${encodeURIComponent(dest)}`,
    regionBased: true
  },
  tableBooking: {
    color: 'pink',
    googleSearch: (dest) => `https://www.google.com/search?q=restaurant+reservations+${encodeURIComponent(dest)}`,
    regionBased: true
  }
};

const resolveLinksMap = (category, bookingLinks) => {
  if (!bookingLinks) return null;
  if (category === 'trains') return bookingLinks.trains?.searchUrls || null;
  if (category === 'buses')  return bookingLinks.buses  || null;
  return bookingLinks[category] || null;
};

const BookingDropdown = ({
  category,
  destination,
  country,
  fromLocation,
  icon: Icon,
  label,
  bookingLinks,
  localServices,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const config = CATEGORY_CONFIG[category];

  const detectedCountry = country || detectCountryFromDestination(destination);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const buildOptions = () => {
    const options = [];
    const seen = new Set();

    const addOption = (opt) => {
      if (!opt || !opt.url) return;
      const key = String(opt.name || '').toLowerCase();
      if (key && seen.has(key)) return;
      if (key) seen.add(key);
      options.push(opt);
    };

    const linksMap = resolveLinksMap(category, bookingLinks);
    const meta     = PROVIDER_META[category] || [];
    if (linksMap) {
      meta.forEach(m => {
        const url = linksMap[m.key];
        if (url) addOption({ name: m.name, url, color: m.color });
      });
      Object.keys(linksMap).forEach(key => {
        if (meta.find(m => m.key === key)) return;
        const url = linksMap[key];
        if (typeof url !== 'string') return;
        const label = key.charAt(0).toUpperCase() + key.slice(1);
        addOption({ name: label, url, color: '#666' });
      });
    }

    if (config.regionBased) {
      const regionServices = getServicesForRegion(category, detectedCountry);
      regionServices.forEach(service => {
        addOption({ name: service.name, url: service.url, color: service.color });
      });
    }

    if (localServices && localServices[category]) {
      localServices[category].forEach(service => {
        if (service?.name && service?.url) {
          addOption({ name: service.name, url: service.url, color: service.color || '#666' });
        }
      });
    }

    let googleUrl;
    if (category === 'trains' || category === 'buses') {
      googleUrl = config.googleSearch(fromLocation, destination);
    } else if (category === 'flights') {
      googleUrl = config.googleSearch(destination, fromLocation);
    } else {
      googleUrl = config.googleSearch(destination);
    }
    addOption({ name: 'Search on Google', url: googleUrl, icon: 'google', color: '#4285F4' });

    return options;
  };

  const options = buildOptions();
  const colorClasses = {
    blue: 'bg-blue-50 hover:bg-blue-100 border-blue-100',
    orange: 'bg-orange-50 hover:bg-orange-100 border-orange-100',
    green: 'bg-green-50 hover:bg-green-100 border-green-100',
    purple: 'bg-purple-50 hover:bg-purple-100 border-purple-100',
    red: 'bg-red-50 hover:bg-red-100 border-red-100',
    pink: 'bg-pink-50 hover:bg-pink-100 border-pink-100',
    indigo: 'bg-indigo-50 hover:bg-indigo-100 border-indigo-100',
    teal: 'bg-teal-50 hover:bg-teal-100 border-teal-100'
  };

  const iconBgClasses = {
    blue: 'bg-blue-500',
    orange: 'bg-orange-500',
    green: 'bg-green-500',
    purple: 'bg-purple-500',
    red: 'bg-red-500',
    pink: 'bg-pink-500',
    indigo: 'bg-indigo-500',
    teal: 'bg-teal-500'
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center gap-3 p-3 rounded-xl transition-colors border cursor-pointer ${colorClasses[config.color]}`}
      >
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center text-white ${iconBgClasses[config.color]}`}>
          {Icon && <Icon />}
        </div>
        <div className="flex-1 min-w-0 text-left">
          <p className="font-medium text-gray-900 text-sm">{label}</p>
          <p className="text-xs text-gray-500 truncate">
            {options.length > 1 ? `${options.length} options` : options[0]?.name}
          </p>
        </div>
        <ChevronDownIcon />
      </button>

      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-white rounded-xl shadow-lg border border-gray-200 py-1 max-h-64 overflow-y-auto">
          {options.map((option, index) => (
            <a
              key={index}
              href={option.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors"
            >
              <div
                className="w-6 h-6 rounded flex items-center justify-center"
                style={{ backgroundColor: option.icon === 'google' ? 'transparent' : option.color }}
              >
                {option.icon === 'google' ? (
                  <GoogleIcon />
                ) : (
                  <span className="text-white text-xs font-bold">
                    {option.name.charAt(0)}
                  </span>
                )}
              </div>
              <span className="flex-1 text-sm text-gray-700">{option.name}</span>
              <ExternalLinkIcon />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingDropdown;
export { REGION_SERVICES, getServicesForRegion, CATEGORY_CONFIG };
